<template>
  <div>
    <div class="sayfahead m-0">
      <h1><small>Bina Sanal Pos</small></h1>
      <el-button type="success" size="small" class="YeniBtn"
                 @click="Submit">
        Kaydet
      </el-button>
    </div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-form :model="FormData" @submit.prevent.native="Submit" class="mt-3" :rules="FormHata" ref="Form">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="Banka Hesap Ünvanı" prop="HesapAdi">
            <el-input v-model="FormData.HesapAdi"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="İrtibat E-Mail" prop="Email">
            <el-input v-model="FormData.Email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="İrtibat Telefon No" prop="Telefon">
            <el-input v-model="FormData.Telefon" v-mask="'### ### ## ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Banka Hesap IBAN" prop="Iban">
            <el-input v-model="FormData.Iban" v-mask="'TR ## #### #### #### #### #### ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="Tooltip" label="Kasa" prop="Kasa_id">

            <el-tooltip class="item" effect="dark" content="Pos ile tahsil edilen bakiye hangi kasada gözükecek"
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-cascader
              placeholder="Kasa Seçiniz"
              :props="{ multiple: false}"
              :options="Kasalar"
              v-model="FormData.Kasa_id"
              collapse-tags
              filterable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item class="Tooltip" label="Komisyonsuz" prop="Komisyon">
            <el-tooltip class="item" effect="dark" content="Tek çekim komisyonu ödeyene yansıanapara içinden kesilsin."
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-switch v-model="FormData.Komisyon"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item class="Tooltip" label="Durum" prop="Durum">
            <el-tooltip class="item" effect="dark" content="Bina Özel Pos durumu"
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-switch v-model="FormData.Durum"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-alert
      type="info"
      :closable="false"
      description="Vergi Dairesi, Vergi No, Adres bilgileri Bina bilgisinden alınacaktır."
    >
    </el-alert>
    <div v-if="BinaBilgi.Pos_id">
      <hr>
      <el-alert
        :type="Durum.Type"
        :closable="false"
        :description="Durum.Aciklama"
      ></el-alert>
      <hr>
      <table class="table table-hover table-bordered">
        <thead>
        <tr>
          <th>1 Taksit</th>
          <th>2 Taksit</th>
          <th>3 Taksit</th>
          <th>4 Taksit</th>
          <th>5 Taksit</th>
          <th>6 Taksit</th>
          <th>7 Taksit</th>
          <th>8 Taksit</th>
          <th>9 Taksit</th>
          <th>10 Taksit</th>
          <th>11 Taksit</th>
          <th>12 Taksit</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{FormData.Taksit1}}</td>
          <td>{{FormData.Taksit2}}</td>
          <td>{{FormData.Taksit3}}</td>
          <td>{{FormData.Taksit4}}</td>
          <td>{{FormData.Taksit5}}</td>
          <td>{{FormData.Taksit6}}</td>
          <td>{{FormData.Taksit7}}</td>
          <td>{{FormData.Taksit8}}</td>
          <td>{{FormData.Taksit9}}</td>
          <td>{{FormData.Taksit10}}</td>
          <td>{{FormData.Taksit11}}</td>
          <td>{{FormData.Taksit12}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!BinaBilgi.Pos_id">Oranlar ve diğer detaylar kayıt olduktan sonra burada gözükecektir.</div>
  </div>
</template>

<script>
  import Yukleniyor from "../../../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ['BinaBilgi'],
    data() {
      return {
        lo: true,
        Kasalar: null,
        FormData: {
          HesapAdi: this.BinaBilgi.Adi,
          Email: null,
          Durum: true,
          Telefon: null,
          Iban: null,
          Kasa_id: null,
          Komisyon: false,
          VergiDairesi: this.BinaBilgi.vDairesi,
          VergiNo: this.BinaBilgi.vNo,
          Adres: this.BinaBilgi.Adres + ' ' + this.BinaBilgi.Sehir,
          Bina_id: this.BinaBilgi.id
        },
        Durum: {
          "Type": "error",
          "Aciklama": "Bina Özel Pos Pasif"
        },
        FormHata: {
          HesapAdi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Email: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Iban: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
      }
    },
    methods: {
      Submit() {
        this.FormData.Bina_id = this.BinaBilgi.id;
        this.$store.dispatch("Post", {
          ...this.FormData,
          path: 'yonetim/bina/pos'
        }).then(response => {
          if (response.Durum == "OK") {
            this.SayfaYukle();
            this.$message.success(response.Mesaj);
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'yonetim/bina/pos/' + this.BinaBilgi.id})
          .then(response => {
            if (response.Status === 'OK') {
              this.FormData = response;
              this.BinaBilgi.Pos_id = response.id
              this.lo = false;
              if (response.Paratika) {
                // ÖDEME KURUMUNA KAYDI YAPILDIYSA
                if (response.Durum) {
                  this.Durum = {
                    "Type": "success",
                    "Aciklama": "Bina Özel Pos Aktif"
                  }
                } else {
                  this.Durum = {
                    "Type": "error",
                    "Aciklama": "Bina Özel Pos Pasif"
                  }
                }
              } else {
                this.Durum = {
                  "Type": "warning",
                  "Aciklama": "Bina özel pos, ödeme kurumu tarafından onaylanması bekleniyor."
                }
              }

            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      if (this.BinaBilgi.Pos_id) this.SayfaYukle();
      this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + this.BinaBilgi.id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kasalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.lo = false;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaPos.vue